/**
 * Registers the service worker that keeps the app's own files for offline use
 * (serviceWorker.ts at the app's root writes it into the build). Only in a production
 * build: the dev server's modules change on every edit.
 */
export function registerServiceWorker(): void {
  if (!import.meta.env.PROD || !('serviceWorker' in navigator)) return;
  window.addEventListener('load', () => {
    // A same-origin script URL, so the Trusted Types default policy allows it.
    navigator.serviceWorker.register('/sw.js', { scope: '/', updateViaCache: 'none' }).catch((error: unknown) => {
      console.warn('Realmery Web will not open offline: the service worker did not register', error);
    });
  });
}
